import { CAPACITIES } from "constants/capacities";
import { usePermissions } from "../components/user/permissions";
import React from "react";

const useUserCapacity = (organizationId, capacity) => {
	const permissions = usePermissions();

	return React.useMemo(() => {
		if (typeof capacity == "object") {
			return permissions.hasCapacities(capacity, organizationId);
		}
		return permissions.hasCapacity(capacity, organizationId);
	}, [organizationId, permissions, capacity]);
};

const useAllUserCapacities = organizationId => {
	const permissions = usePermissions();

	return React.useMemo(() => {
		return Array.from(permissions.capacityOrga(organizationId));
	}, [organizationId, permissions]);
};

const useCheckpointsCapacities = organizationId => {
	const canRead = useUserCapacity(organizationId, CAPACITIES.CHECKLIST.READ);
	const canAdd = useUserCapacity(organizationId, CAPACITIES.CHECKLIST.ADD);
	const canDelete = useUserCapacity(
		organizationId,
		CAPACITIES.CHECKLIST.DELETE
	);
	const canEdit = useUserCapacity(organizationId, CAPACITIES.CHECKLIST.EDIT);

	return {
		canAdd,
		canRead,
		canDelete,
		canEdit
	};
};

const useEventConfigCapacities = organizationId => {
	const canRead = useUserCapacity(organizationId, [
		CAPACITIES.EVENT_CONFIG.READ,
		CAPACITIES.ZONE.READ,
		CAPACITIES.POPULATION.READ
	]);
	const canManage = useUserCapacity(organizationId, [
		CAPACITIES.EVENT_CONFIG.MANAGE,
		CAPACITIES.ZONE.MANAGE,
		CAPACITIES.POPULATION.MANAGE
	]);

	return {
		canRead,
		canManage
	};
};

const useAttendeesCapacities = organizationId => {
	const canRead = useUserCapacity(organizationId, [
		CAPACITIES.ATTENDEES.RO,
		CAPACITIES.ATTENDEES.MANAGE
	]);
	const canManage = useUserCapacity(
		organizationId,
		CAPACITIES.ATTENDEES.MANAGE
	);

	return {
		canRead,
		canManage
	};
};

const usePartnersCapacities = organizationId => {
	const canManage = useUserCapacity(
		organizationId,
		CAPACITIES.PARTNER.ADVANCED_CONFIG
	);
	return {
		canManage
	};
};

export {
	useUserCapacity as default,
	useAllUserCapacities,
	useCheckpointsCapacities,
	useEventConfigCapacities,
	useAttendeesCapacities,
	usePartnersCapacities
};
